export default __webpack_public_path__ + "images/1e0441ab5bf466c90d9a490b71f8aad2.svg";